import React, { Component } from 'react';
import { connect } from 'react-redux';
import { Statistic, Card, Grid, Loader, Dimmer, Button, Icon } from 'semantic-ui-react';
import {
	countFolderSentToGesLab,
	getNotGeneratedFolders,
	patchNotGeneratedFolders
} from 'services/folder';
import { getGeslabExport } from 'services/geslab';
import moment from 'moment';
import CustomPagination from 'components/CustomPagination';
import FolderListItem from 'features/SecretaryHome/components/FolderListItem';
import SearchInput from 'features/Lab/components/SearchInput';

const styles = {
	folder: {
		backgroundColor: '#fff',
		width: '100%',
		padding: 10,
		display: 'flex',
		borderRadius: '0',
		marginTop: '5px',
		boxShadow: '0px 9px 35px -23px rgba(148,148,148,1)',
		alignItems: 'center',
		marginLeft: 15,
		marginRight: 15,
		position: 'relative',
	},
	roundHeaderContainer: {
		height: 40,
		backgroundColor: '#43b39e',
		width: '100%',
		padding: 10,
		display: 'flex',
		borderRadius: '4px 4px 0 0',
		boxShadow: '0px 9px 35px -23px rgba(148,148,148,1)',
		position: 'relative',
	},
};

class Dashboard extends Component {
	constructor(props) {
		super(props);

		this.folderTimeout = 0;

		this.state = {
			total: null,
			week: null,
			yersteday: null,
			today: null,
			currentPage: 0,
			pages: 0,
			folderTotalCount: 0,
			folders: null,
			isLoading: false,
			currentFolderFilterSearch: '',
		};
	}

	componentDidMount() {
		this.loadAll();
	}

	loadList = (page = 1) => {
		this.setState({ isLoading: true });
		this.props
			.getNotGeneratedFolders(this.state.currentFolderFilterSearch, page)
			.then((res) => {
				const { data } = res.payload;
				this.setState({
					currentPage: data.page,
					pages: data.numberOfPages,
					folderTotalCount: data.totalCount,
					folders: data.results,
					isLoading: false,
				});
			});
	};

	loadAll = () => {
		this.loadList(this.state.currentPage !== 0 ? this.state.currentPage : 1);
		this.props.countFolderSentToGesLab().then((totalRes) =>
			this.props
				.countFolderSentToGesLab(
					moment().startOf('isoweek').format('YYYY-MM-DD'),
					moment().endOf('isoweek').format('YYYY-MM-DD')
				)
				.then((weekRes) =>
					this.props
						.countFolderSentToGesLab(
							moment().add(-1, 'day').format('YYYY-MM-DD')
						)
						.then((yerstedayRes) =>
							this.props
								.countFolderSentToGesLab(moment().format('YYYY-MM-DD'))
								.then((todayRes) =>
									this.setState({
										total: totalRes.payload?.data,
										week: weekRes.payload?.data,
										yersteday: yerstedayRes.payload?.data,
										today: todayRes.payload?.data,
									})
								)
						)
				)
		);
	};

	changeFolderSearchInput = (value) => {
		if (this.folderTimeout) clearTimeout(this.folderTimeout);

		if (value !== this.state.currentFolderFilterSearch) {
			this.setState({ currentFolderFilterSearch: value });
		}
		// Trigger the search after the user stopped typing
		this.folderTimeout = setTimeout(() => {
			if (
				this.state.currentFolderFilterSearch.length >= 3 ||
				this.state.currentFolderFilterSearch.length === 0
			) {
				this.loadList(1);
			}
		}, 500);
	};

	render() {
		const {
			total,
			week,
			yersteday,
			today,
			currentPage,
			pages,
			folderTotalCount,
			folders,
			isLoading,
			currentFolderFilterSearch,
		} = this.state;

		return (
			<div
				style={{
					height: '100vh',
					overflowY: 'scroll',
				}}
			>
				<Dimmer active={this.props.geslab.loading}>
					<Loader />
				</Dimmer>
				<Grid
					className='ui container'
					style={{
						maxHeight: '100vh',
						maxWidth: '90%',
						display: 'flex',
						justifyContent: 'center',
						paddingTop: 43,
					}}
				>
					<Grid.Row>
						<Card style={{ marginTop: 10, display: 'flex', flex: 1 }}>
							<Card.Content>
								<Card.Header>Exports vers GesLab</Card.Header>
								<Card.Group>
									<Card>
										<Card.Content>
											<Card.Header>Total</Card.Header>
											<Statistic.Group>
												<Statistic>
													<Statistic.Value>{total?.folders}</Statistic.Value>
													<Statistic.Label>Dossiers</Statistic.Label>
												</Statistic>
												<Statistic>
													<Statistic.Value>
														{total?.prescriptions}
													</Statistic.Value>
													<Statistic.Label>Prescriptions</Statistic.Label>
												</Statistic>
											</Statistic.Group>
										</Card.Content>
									</Card>
									<Card>
										<Card.Content>
											<Card.Header>Semaine</Card.Header>
											<Statistic.Group>
												<Statistic>
													<Statistic.Value>{week?.folders}</Statistic.Value>
													<Statistic.Label>Dossiers</Statistic.Label>
												</Statistic>
												<Statistic>
													<Statistic.Value>
														{week?.prescriptions}
													</Statistic.Value>
													<Statistic.Label>Prescriptions</Statistic.Label>
												</Statistic>
											</Statistic.Group>
										</Card.Content>
									</Card>
									<Card>
										<Card.Content>
											<Card.Header>Hier</Card.Header>
											<Statistic.Group>
												<Statistic>
													<Statistic.Value>
														{yersteday?.folders}
													</Statistic.Value>
													<Statistic.Label>Dossiers</Statistic.Label>
												</Statistic>
												<Statistic>
													<Statistic.Value>
														{yersteday?.prescriptions}
													</Statistic.Value>
													<Statistic.Label>Prescriptions</Statistic.Label>
												</Statistic>
											</Statistic.Group>
										</Card.Content>
									</Card>
									<Card>
										<Card.Content>
											<Card.Header>Aujourd'hui</Card.Header>
											<Statistic.Group>
												<Statistic>
													<Statistic.Value>{today?.folders}</Statistic.Value>
													<Statistic.Label>Dossiers</Statistic.Label>
												</Statistic>
												<Statistic>
													<Statistic.Value>
														{today?.prescriptions}
													</Statistic.Value>
													<Statistic.Label>Prescriptions</Statistic.Label>
												</Statistic>
											</Statistic.Group>
										</Card.Content>
									</Card>
								</Card.Group>
							</Card.Content>
						</Card>
					</Grid.Row>
					<Grid.Row style={{ paddingTop: 0 }}>
						<SearchInput
							onChange={(e) => this.changeFolderSearchInput(e.target.value)}
							current={currentFolderFilterSearch}
							resetInput={async () => {
								await this.setState({ currentFolderFilterSearch: '' });
								this.loadList(1);
							}}
							placeholder={'Rechercher un dossier'}
						/>
					</Grid.Row>
					<Grid.Row style={styles.roundHeaderContainer}>
						<Grid.Column
							computer={9}
							tablet={9}
							mobile={9}
							style={{ color: 'white' }}
						>
							Dossiers non exportés vers GesLab
						</Grid.Column>
						<Grid.Column
							computer={4}
							tablet={4}
							mobile={4}
							style={{
								color: 'white',
								display: 'flex',
								justifyContent: 'flex-end',
							}}
						>
							Total: {folderTotalCount}
						</Grid.Column>
						<Grid.Column 
						computer={3}
						tablet={3}
						mobile={3}
						style={{ color: 'white', marginTop: '-4px'}}
						>
						<Button
							icon
							color='orange'
							size='tiny'
							onClick={async (e) => {
								e.preventDefault();
								this.setState({ isLoading: true });
								await this.props.patchNotGeneratedFolders();
								setTimeout(() => {
									this.loadList();	
								}, 500)
								
							}													
							}
						>
							<Icon name='upload' /> Générer tout
						</Button>	
						</Grid.Column>
					</Grid.Row>
					<Grid.Row>
						{isLoading && <Loader active />}
						{!isLoading && folderTotalCount > 0 ? (
							<Grid
								style={{
									display: 'flex',
									flex: 1,
								}}
							>
								{folders.map((f) => (
									<FolderListItem
										folder={f}
										key={`fli-${f.id}`}
										generalParameters={this.props.generalParameters}
										user={this.props.user}
										onPressText={'Générer'}
										handleOnPress={async () => {
											await this.props.getGeslabExport(f.id);
											this.loadAll();
										}}
									/>
								))}
							</Grid>
						) : (
							'Aucun dossier'
						)}
					</Grid.Row>
					<Grid.Row>
						<CustomPagination
							activePage={currentPage}
							totalPages={pages}
							onPageChange={(e, { activePage }) => {
								this.loadList(activePage);
							}}
						/>
					</Grid.Row>
				</Grid>
			</div>
		);
	}
}

const mapStateToProps = (state) => {
	return {
		generalParameters: state.generalParameters,
		user: state.user,
		geslab: state.geslab,
	};
};

const mapDispatchToProps = {
	countFolderSentToGesLab,
	getNotGeneratedFolders,
	patchNotGeneratedFolders,
	getGeslabExport,
};

export default connect(mapStateToProps, mapDispatchToProps)(Dashboard);
